import React from 'react';

import api     from '../../../../../api';
import values  from '../../../../../values';
import Context from '../../../../../context';

import ProvinceScreen from '..';

import { useQuery          } from 'react-query';
import { TModal            } from '../../../../../types/common.type';
import { locationNamespace } from '../../../../../types/location.namespace';
import successHandler from "../../../../../utils/successHandler";

const ProvinceContainer: React.FC = (): React.ReactElement => {

  // # =================================================================================================================
  // # --------------------------------------------- Start Validate Values ---------------------------------------------

  const [showModal, setShowModal] = React.useState<TModal>('NONE');
  const [isLoading, setIsLoading] = React.useState<boolean>(false);
  const [selectedProvince, setSelectedProvince] = React.useState<locationNamespace.province.index | undefined>(undefined);
  const [requestProvince , setRequestProvince ] = React.useState<locationNamespace.province.request>({
    limit: 10,
    page : 1 ,
  });

  // # ---------------------------------------------- End Validate Values ----------------------------------------------
  // # =================================================================================================================

  // ! =================================================================================================================
  // ! ------------------------------------------------ Start Call API -------------------------------------------------

  const getProvince = useQuery(
    [values.useQueryKeys.locationGetProvince, requestProvince],
    () => api.get.common.searchProvince(requestProvince)
  );

  // ! ------------------------------------------------- End Call API --------------------------------------------------
  // ! =================================================================================================================

  // * =================================================================================================================
  // * -------------------------------------------- Start Local Functions ----------------------------------------------

  async function createFunction(event: locationNamespace.province.create): Promise<void> {
    setIsLoading(true);
    const result = await api.post.administrator.createProvince(event);
    successHandler(result?.CODE)
    await getProvince.refetch();
    setShowModal('NONE');
    setIsLoading(false);
  }

  async function updateFunction(event: locationNamespace.province.update): Promise<void> {
    setIsLoading(true);
    if (!selectedProvince) return;
    const result = await api.patch.administrator.updateProvince(selectedProvince?._id, event);
    successHandler(result?.CODE)
    await getProvince.refetch();
    setShowModal('NONE');
    setIsLoading(false);
  }

  async function deleteFunction(): Promise<void> {
    setIsLoading(true);
    if (!selectedProvince) return;
    const result = await api.dele.administrator.deleteProvince(selectedProvince?._id);
    successHandler(result?.CODE)
    await getProvince.refetch();
    setShowModal('NONE');
    setIsLoading(false);
  }

  // * --------------------------------------------- End Local Functions -----------------------------------------------
  // * =================================================================================================================

  // ? =================================================================================================================
  // ? ----------------------------------------------- Start Return View -----------------------------------------------

  return (
    <Context.Location.Province.Provider value={{
      showModal       ,
      isLoading       ,
      requestProvince ,
      selectedProvince,
      setShowModal       ,
      setIsLoading       ,
      createFunction     ,
      updateFunction     ,
      deleteFunction     ,
      setRequestProvince ,
      setSelectedProvince,
    }}>
      <ProvinceScreen rqData={getProvince} />
    </Context.Location.Province.Provider>
  );

  // ? ------------------------------------------------ End Return View ------------------------------------------------
  // ? =================================================================================================================
};

export default ProvinceContainer;
